import { keyframes, css } from 'styled-components';
var show = keyframes(["0%{opacity:0;transform:translateY(-9px);}100%{opacity:1;transform:translateY(0);}"]);
export var showAnimation = css(["animation:", " 0.25s cubic-bezier(0,1,1,1);"], show);